import React,{Fragment} from 'react'
 
class TweetContents extends React.Component{

 	render() {

   	
   	switch (this.props.tweetId) {
     
      case '1034104675828682752':
       return(
        <Fragment>
          Love using <b>@plickers</b> as a quick check for understanding! It's awesome feedback — instantly shows me who needs more practice and who's ready to move on! <b>#proud2bFSES</b>
        </Fragment>
  		 )
    

      case '1033085612172165120':
       return(
        <Fragment>
          What to do when the students don’t have their tablets and you don’t want them on their phones???  You go with <b>@plickers</b>!  Statistics <b>#7thPd</b> Kids loved it and easy way to get immediate feedback! <b>@KleinOak</b>
        </Fragment>
       )

      case '1035621109469728774':
       return(
        <Fragment>
          Be high-tech, even without student devices! We tried <b>@plickers</b> for the first time today - super easy to set up, and my students really enjoyed it. Great for a quick pre-assessment! <b>#blendedlearning</b> <b>#medicalinterventions</b> <b>@chccs</b> <b>@PLTWorg</b>
        </Fragment>
       )


      case '1030300303374118913':
       return(
        <Fragment>
          If you haven’t tried Plickers, you should check it out! It’s a very quick and easy tool where students do NOT need to take the time to get out technology, you only need your phone to scan their answers. I love this for quick warmups. I have them glue their Plicker card in INB!
        </Fragment>
       )

      case '1035186446766882816':
       return(
        <Fragment>
          I can’t get enough of <b>#PLICKERS</b>!! Why wouldn’t you want to use it? You get real time results of your students understanding based on questions that you can create that align with your standards. And guess what? Students absolutely LOVE them!!! <b>@plickers</b> <b>@BCES_1</b> <b>#OtherjetsMatter</b>
        </Fragment>
       )

      case '1033408610196447232':
       return(
        <Fragment>
          Needing to create MANY formative assessments for US History ... enter <b>@plickers</b> and SOL Pass!  Quick checks, exit tickets, game shows ... this is going to be so easy!  If you haven't used Plickers, you need to give it a try! <b>#thisjobisfun</b> <b>#middleschool</b> <b>#Plickersmakesiteasy</b>
        </Fragment>
       )

      case '1035528699989434370':
       return(
        <Fragment>
          Pre-assessed our science vocab today and introduced Plickers! Kids are big fans! Love that they think it’s a game! <b>#LISDParkside</b> <b>#LISDelemscience</b>
        </Fragment>
       )

      case '1029693968504827905':
       return(
        <Fragment>
          P4 loved trying <b>@plickers</b> for the first time. We can use it to give feedback and answer quizzes.  Mrs H was very excited that it worked, and gave lots of helpful information to help with class planning.
        </Fragment>
       )

      case '1031705048714301442':
       return(
        <Fragment>
          Just tried <b>@plickers</b> for the first time today and LOVED IT!!! Introduced it to my teachers at our faculty meeting today and it was a hit. So excited to share new ideas with my peeps! <b>@GESGators</b> <b>@JEFCOEDTech</b> <b>#teachertech</b>
        </Fragment>
        )

      case '1034510539987345410':
       return(
        <Fragment>
          Exit ticket quick check using <b>@plickers</b> in Mrs. Calvin’s 8th grade history class!! <b>#hawksome</b>
        </Fragment>
        )

      case '1035549143794700291':
       return(
        <Fragment>
          Our class using <b>@plickers</b> to review Place Value! ☺️ <b>#CHANgetheclass</b> <b>#peaceloveandrhoads</b>
        </Fragment>
        )

      case '961065696594546688':
       return(
        <Fragment>
          Pride and Prejudice & Plickers in the classroom is a hit with my freshies! <b>@CaptGrizzly</b>
        </Fragment>
        )



       

       

      default:
        return null;    

  }}}
   

export default TweetContents
